import React from 'react';

import { SongNameWithPhoto } from '@/component';
import { generalHelpers } from '@/helpers';

interface Column {
  field: string;
  headerName: string;
  className?: string;
  isCheckbox?: boolean;
  isSort?: boolean;
  renderCell?: (row?: object) => React.ReactNode /*keyof JSX.IntrinsicElements*/;
}

export const column: Array<Column> = [
  {
    field: 'songs',
    headerName: 'Songs',
    renderCell: (row) => <SongNameWithPhoto song={row} />,
  },
  {
    field: 'total_views',
    headerName: 'Total Views',
  },
  {
    field: 'total_likes',
    headerName: 'Likes',
  },
  {
    field: 'duration',
    headerName: 'Duration',
    renderCell: (row: any) => <p>{generalHelpers.convertDurationToMinutes(row.duration)}</p>,
  },
  {
    field: 'total_favorite',
    headerName: 'Saves',
  },
];

export const rows = [
  {
    id: 1,
    songs: 'rr 1',
    totalViews: '10',
    dateAdded: '20/12/2020',
    duration: '3:30',
  },
  {
    id: 2,
    songs: 'Song 2',
    totalViews: '10',
    dateAdded: '20/12/2020',
    duration: '3:30',
  },
  {
    id: 3,
    songs: 'Song 3',
    totalViews: '10',
    dateAdded: '20/12/2020',
    duration: '3:30',
  },
  {
    id: 4,
    songs: 'Song 4',
    totalViews: '10',
    dateAdded: '20/12/2020',
    duration: '3:30',
  },
  {
    id: 5,
    songs: 'Song 5',
    totalViews: '10',
    dateAdded: '20/12/2020',
    duration: '3:30',
  },
  {
    id: 6,
    songs: 'Song 6',
    totalViews: '10',
    dateAdded: '20/12/2020',
    duration: '3:30',
  },
  {
    id: 7,
    songs: 'Song 7',
    totalViews: '10',
    dateAdded: '20/12/2020',
    duration: '3:30',
  },
  {
    id: 8,
    songs: 'Song 8',
    totalViews: '10',
    dateAdded: '20/12/2020',
    duration: '3:30',
  },
  {
    id: 9,
    songs: 'Song 9',
    totalViews: '10',
    dateAdded: '20/12/2020',
    duration: '3:30',
  },

  {
    id: 10,
    songs: 'Song 10',
    totalViews: '10',
    dateAdded: '20/12/2020',
    duration: '3:30',
  },

  {
    id: 11,
    songs: 'Song 11',
    totalViews: '10',
    dateAdded: '20/12/2020',
    duration: '3:30',
  },

  {
    id: 12,
    songs: 'Song 12',
    totalViews: '10',
    dateAdded: '20/12/2020',
    duration: '3:30',
  },

  {
    id: 13,
    songs: 'Song 13',
    totalViews: '10',
    dateAdded: '20/12/2020',
    duration: '3:30',
  },

  {
    id: 14,
    songs: 'Song 14',
    totalViews: '10',
    dateAdded: '20/12/2020',
    duration: '3:30',
  },

  {
    id: 15,
    songs: 'Song 15',
    totalViews: '10',
    dateAdded: '20/12/2020',
    duration: '3:30',
  },

  {
    id: 16,
    songs: 'Song 16',
    totalViews: '10',
    dateAdded: '20/12/2020',
    duration: '3:30',
  },

  {
    id: 17,
    songs: 'Song 17',
    totalViews: '10',
    dateAdded: '20/12/2020',
    duration: '3:30',
  },

  {
    id: 18,
    songs: 'Song 18',
    totalViews: '10',
    dateAdded: '20/12/2020',
    duration: '3:30',
  },

  {
    id: 19,
    songs: 'Song 19',
    totalViews: '10',
    dateAdded: '20/12/2020',
    duration: '3:30',
  },

  {
    id: 20,
    songs: 'Song 20',
    totalViews: '10',
    dateAdded: '20/12/2020',
    duration: '3:30',
  },
];
